import { Injectable } from '@angular/core';
import { CommunicationManagerService } from './communication-manager.service';
import { CostItemComment } from '../models/cost-item';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CostItemCommentService {
  private routeBase = 'costItemComment';

  constructor(private cm: CommunicationManagerService) {}

  getCostItemComments(costItemid: string, projectId: string) {
    return this.cm.get(`${this.routeBase}/all/${costItemid}`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  getAllCostItemCommentsForProject(projectId: string): Observable<Array<CostItemComment>> {
    return this.cm.get(`${this.routeBase}/project`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  createCostItemComment(
    costItemId: string,
    comment: string,
    projectId: string
  ) {
    return this.cm.postAndGetJson(
      `${this.routeBase}/${costItemId}`,
      { text: comment },
      [{ headerName: 'projectId', headerValue: projectId }]
    );
  }

  updateCostItemComment(
    commentId: string,
    text: string,
    projectId: string
  ) {
    return this.cm.put(`${this.routeBase}/${commentId}`, { text: text }, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  deleteCostItemComment(commentId: string, projectId: string) {
    return this.cm.delete(`${this.routeBase}/${commentId}`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }
}
